export const SITE_URL = "https://hareesh.web.app";

export const person = {
  name: "Hareesh Rajendran",
  headline: "YouTuber | Founder and CEO at Hayan Tech | Ex Zoho | Software Engineer",
  shortHeadline: "Founder • Software Engineer • YouTuber",
  location: "Chennai, Tamil Nadu, India",
  email: "info@hayan.in",
  image: `${SITE_URL}/og-image.png`,
  description:
    "Hareesh Rajendran is a Chennai-based software engineer, founder of Hayan Tech and Vanakkam DSA, and Tamil technology YouTuber focused on System Design, AI Agents, Agentic AI and software engineering.",
  about:
    "Founder of Vanakkam DSA, a Tamil cohort-based DSA and interview preparation platform with 1000+ paying students across 7 cohorts. Full-time YouTuber with 123K subscribers, teaching System Design, AI Agents and Agentic AI in Tamil. Previously Member of Technical Staff at Zoho and Senior Software Engineer and Product Engineer at Highbrow Technology. LeetCode Knight with a contest rating of 2,067 and top 1.84%.",
  knowsAbout: [
    "Software engineering",
    "System Design",
    "AI Agents",
    "Agentic AI",
    "DSA",
    "Interview preparation",
    "Developer tools",
    "Automation",
    "AI-assisted product development",
  ],
};

export const links = {
  site: SITE_URL,
  vanakkamDsa: "https://vanakkamdsa.com",
  cleverhire: "https://cleverhire.ai",
  github: "https://github.com/hareesh-r",
  githubDsaJava:
    "https://github.com/hareesh-r/Data-Structures-And-Algorithms-DSA-in-Java",
  linkedin: "https://www.linkedin.com/in/hareesh-r",
  leetcode: "https://leetcode.com/u/hareeshprogrammer",
  x: "https://x.com/hareesh_dev",
  twitter: "https://twitter.com/hareesh_dev",
  instagram: "https://www.instagram.com/hareeshrajendran_/",
  youtube: "https://www.youtube.com/@hareeshrajendran",
  youtubeChannel: "https://www.youtube.com/channel/UCdFmcrrlvC6rSYEL9mZQ_4g",
  facebook: "https://www.facebook.com/hareeshprogrammer",
  tamilnaduTech: "https://tamilnadu.tech",
};

export const sameAs = [
  links.linkedin,
  links.github,
  links.youtube,
  links.youtubeChannel,
  links.leetcode,
  links.x,
  links.twitter,
  links.instagram,
  links.vanakkamDsa,
];

export const stats = [
  { value: "123K", label: "YouTube subscribers" },
  { value: "40K", label: "Instagram followers" },
  { value: "1000+", label: "Paying students" },
  { value: "7", label: "Vanakkam DSA cohorts" },
  { value: "4,000+", label: "Problems solved across platforms" },
  { value: "780", label: "LeetCode problems solved" },
  { value: "2,067", label: "LeetCode contest rating" },
  { value: "Top 1.84%", label: "LeetCode global rank" },
  { value: "Knight", label: "LeetCode badge" },
  { value: "Top 20", label: "India rank in one contest" },
  { value: "1.8K", label: "GitHub followers" },
  { value: "69", label: "GitHub repositories" },
];

export const pages = {
  home: {
    path: "/",
    title: "Hareesh Rajendran | Founder, Software Engineer & YouTuber",
    description: person.description,
  },
  about: {
    path: "/about",
    title: "About Hareesh Rajendran | Founder of Vanakkam DSA",
    description:
      "About Hareesh Rajendran, Chennai-based software engineer, founder of Hayan Tech and Vanakkam DSA, and Tamil YouTuber teaching System Design, AI Agents and Agentic AI.",
  },
  experience: {
    path: "/experience",
    title: "Experience | Hareesh Rajendran",
    description:
      "Career of Hareesh Rajendran: Founder and CEO at Hayan Tech, Product Engineer and Senior Software Engineer at Highbrow Technology, and Member of Technical Staff at Zoho.",
  },
  projects: {
    path: "/projects",
    title: "Projects | Hareesh Rajendran",
    description:
      "Projects by Hareesh Rajendran, including Vanakkam DSA, Cleverhire, Timesheet Tracker, Zgraph and open-source DSA and automation work.",
  },
  work: {
    path: "/work",
    title: "Projects | Hareesh Rajendran",
    description:
      "Projects by Hareesh Rajendran, including Vanakkam DSA, Cleverhire, Timesheet Tracker and earlier software builds.",
  },
  skills: {
    path: "/skills",
    title: "Skills | Hareesh Rajendran",
    description:
      "Technical skills of Hareesh Rajendran across Java, JavaScript, Python, React, GraphQL, Node.js, Spring, Firebase, n8n and Zoho CRM.",
  },
  vanakkamDsa: {
    path: "/vanakkam-dsa",
    title: "Vanakkam DSA | Founded by Hareesh Rajendran",
    description:
      "Vanakkam DSA is a Tamil cohort-based DSA and interview preparation platform founded by Hareesh Rajendran, with 1000+ paying students across 7 cohorts.",
  },
  youtube: {
    path: "/youtube",
    title: "Hareesh Rajendran YouTube | System Design, AI Agents & DSA",
    description:
      "Hareesh Rajendran is a Tamil technology YouTuber with 123K subscribers, teaching System Design, AI Agents, Agentic AI, DSA and software engineering.",
  },
  speaking: {
    path: "/speaking",
    title: "Speaking & Community | Hareesh Rajendran",
    description:
      "Talks, workshops and community work by Hareesh Rajendran, including Chennai React, FOSS United, JSLovers, Namma Flutter and hackathon jury roles.",
  },
  openSource: {
    path: "/open-source",
    title: "Open Source | Hareesh Rajendran",
    description:
      "Open-source work by Hareesh Rajendran, including contributions to Tamilnadu.tech, a DSA in Java repository, and a GitHub profile with 1.8K followers.",
  },
  contact: {
    path: "/contact",
    title: "Contact Hareesh Rajendran",
    description:
      "Contact Hareesh Rajendran or follow him on YouTube, LinkedIn, GitHub, LeetCode, X and Instagram.",
  },
  feats: {
    path: "/blog",
    title: "Features | Hareesh Rajendran",
    description:
      "Selected work, internships, coding profiles and features of Hareesh Rajendran, including LeetCode Knight standing and Vanakkam DSA.",
  },
};

export const navLinks = [
  { to: "/about", label: "About" },
  { to: "/experience", label: "Experience" },
  { to: "/projects", label: "Projects" },
  { to: "/vanakkam-dsa", label: "Vanakkam DSA" },
  { to: "/youtube", label: "YouTube" },
  { to: "/speaking", label: "Speaking" },
  { to: "/open-source", label: "Open Source" },
  { to: "/skills", label: "Skills" },
  { to: "/contact", label: "Contact" },
];
